export const RADAR_GRID_IDS = {
  // GeoJSON Sources
  RADAR_SOURCE_ID: "RadarGridSourceId",
  RG_PATH_SOURCE_ID: "radarGridPathSourceId",
  FUTURE_WAKE_SOURCE_ID: "radarGridWakeFutureLineSourceId",
  CAMERA_SOURCE_ID: "radarGridCameraMasterSourceId",
  CAMERA_PULSING_SOURCE_ID: "radarGridCameraMasterPulsingSourceId",

  // Mapbox Layers
  RADAR_LAYER_ID: "RadarGridMapLayerId",
  RG_PATH_LAYER_ID: "radarGridPathLayerId",
  FUTURE_WAKE_LAYER_ID: "radarGridWakeFutureLineLayerId",
  FRAME_LAYER_ID: "radarGridFrameLayerId",
  CAMERA_LAYER_ID: "radarGridCameraMasterLayerId",
  CAMERA_PULSING_LAYER_ID: "radarGridCameraMasterPulsingLayerId",

  // Mapbox Images
  CAMERA_PULSING_IMAGE_ID: "radarGridCameraMasterPulsingImageId",
  CAMERA_PULSING_MANUAL_IMAGE_ID: "radarGridCameraMasterPulsingManualImageId",
};

export const RG_RISK_LEVEL = {
  SAFE: 0,
  CAUTION: 5,
  DANGER: 10,
};

export const RADAR_GRID_OBJECT_KIND = {
  SHIP: "ship",
  CARGO: "cargo",
  CRANE: "crane",
  BARGE: "barge",
  TUG: "tug",
  PASSENGER: "passenger",
  FISHING: "fishing",
  BOAT: "boat",
  BUOY: "buoy",
  FLOATING: "floating",
  PLEASURE: "pleasure",
  AMBIGUOUS: "ambiguous",
};

export const RADAR_GRID_OBJECT_RISK_LEVEL = {
  [RG_RISK_LEVEL.SAFE]: {
    label: "safe",
    labelJa: "安全",
    color: "#0ED463",
    blinkColor: "rgb(14, 212, 99)",
    brinkIconId: "rg-icon-blink-safe",
    brinkOtherKindIconId: "rg-icon-blink-target-safe",
    frameIconId: "rg-icon-frame-safe",
    frameIcon: "rg-target-vessel-safe-default",
  },
  [RG_RISK_LEVEL.CAUTION]: {
    label: "caution",
    labelJa: "注意",
    color: "#EFF335",
    blinkColor: "rgb(242, 246, 28)",
    brinkIconId: "rg-icon-blink-caution",
    brinkOtherKindIconId: "rg-icon-blink-target-caution",
    frameIconId: "rg-icon-frame-caution",
    frameIcon: "rg-target-vessel-caution-default",
  },
  [RG_RISK_LEVEL.DANGER]: {
    label: "danger",
    labelJa: "危険",
    color: "#F23D3D",
    blinkColor: "rgb(235, 87, 87)",
    brinkIconId: "rg-icon-blink-danger",
    brinkOtherKindIconId: "rg-icon-blink-target-danger",
    frameIconId: "rg-icon-frame-danger",
    frameIcon: "rg-target-vessel-danger-default",
  },
};

export const RG_RISK_LEVEL_THRESHOLD = {
  [RG_RISK_LEVEL.SAFE]: 0, // 有効なリスクレベルとして扱う下限
  [RG_RISK_LEVEL.CAUTION]: 3,
  [RG_RISK_LEVEL.DANGER]: 8,
  MAX: 10, // 有効なリスクレベルとして扱う上限
};

export const TRACK_IMG = {
  SAFE: require("@/assets/images/radarGrid/track_safe.svg"),
  CAUTION: require("@/assets/images/radarGrid/track_caution.svg"),
  DANGER: require("@/assets/images/radarGrid/track_danger.svg"),
};
